export class NotificationTaskType {
	public index;
	
	constructor(obj) {
		this.index = obj.index;
	}
} 
